import { round } from 'lodash';
import { FeeTemplateFormData } from '..';

const recalculatePerformanceFee = (
  performanceFees: FeeTemplateFormData['performanceFees'],
  name: string,
  value: string | number,
  index: number,
) => {
  if (!name || (!value && value !== 0 && value !== '')) return performanceFees;

  if (name === 'vatPercentage') {
    const vatMultiplier = +value === 20 ? 1.2 : 1;

    // update gross fee
    performanceFees[index].feePercentageIncVAT = round(
      performanceFees[index].feePercentageExVAT * vatMultiplier,
      2,
    );

    // update field
    performanceFees[index].vatPercentage = +value;
    return performanceFees;
  } else {
    const vatMultiplier = performanceFees[index].vatPercentage === 20 ? 1.2 : 1;

    // update gross fee
    performanceFees[index].feePercentageIncVAT = round(
      +value * vatMultiplier,
      2,
    );

    // update field
    performanceFees[index].feePercentageExVAT = round(+value, 8);

    return performanceFees;
  }
};

export default recalculatePerformanceFee;
